import * as React from 'react';
import {
  RootContext,
  AbstractForm,
  MnInputFile,
  MnInputTextarea,
  MnInputRadioGroup,
  MnButton,
  InterviewValidators,
  InterviewsSelects,
  SvgPlusIcon,
  UserApiV1TreatmentPath,
  TermsInstitutionsPath,
  RegionalMedicalCooperationTermsPath,
  UserApiV1InstitutionUploadFilesPath,
  CompleteInstitutionMenuTreatmentPath,
} from '../../../index';

export default class InterviewForm extends AbstractForm {
  static contextType = RootContext;

  maxText = 1000;

  constructor (props) {
    super(props);
    this.state = {
      isSaved: false, // 保存チェック
    };
    this.renderTextarea = this.renderTextarea.bind(this);
    this.renderRadio = this.renderRadio.bind(this);
    this.renderFile = this.renderFile.bind(this);
    this.onChangeText = this.onChangeText.bind(this);
    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.onChangeFiles = this.onChangeFiles.bind(this);
  }

  componentDidMount () {
    const ids = location.pathname.split('/').filter(s => s !== '').slice(-2);
    this.context.showLoading();
    this.context.fetch(UserApiV1TreatmentPath(ids[0])).then(body => {
      this.files = body.result.menu.interview_settings.map(setting => {
        if (setting.input_type === 'file') {
          return React.createRef();
        }
        return null;
      });
      this.setState({
        treatment: body.result,
        menu: body.result.menu,
        interviews: body.result.interviews,
      });
    }).finally(() => {
      this.context.hideLoading();
    });

    // 問診が保存されないまま遷移する場合はすべてのファイルを削除
    window.addEventListener('beforeunload', () => {
      if (!this.state.isSaved) {
        this.files.map(file => {
          if (file) {
            file.current.deleteAll();
          }
        });
      }
    });
  }

  onChangeText (e) {
    const interviews = this.state.interviews.map(interview => {
      if (interview.interview_setting_code === e.name) {
        interview.text = e.value;
      }
      return interview;
    });
    this.setState({ interviews: interviews });
  }

  onChangeSelect (e) {
    const interviews = this.state.interviews.map(interview => {
      if (interview.interview_setting_code === e.name) {
        interview.select = e.value;
      }
      return interview;
    });
    this.setState({ interviews: interviews });
  }

  onChangeFiles (e) {
    const interviews = this.state.interviews.map(interview => {
      if (interview.interview_setting_code === e.name) {
        interview.interview_images = e.files.map(file => {
          return { code: file.info.code };
        });
      }
      return interview;
    });
    this.setState({ interviews: interviews });
  }

  validation () {
    return new Promise((resolve, reject) => {
      if (this.validators.length === 0) {
        resolve();
      }
      let count = 0;
      this.validators.map(validate => {
        validate.validate().catch(() => {
          count++;
        }).finally(() => {
          validate.run = true;
          if (this.validators.findIndex(validate => !validate.run) === -1) {
            if (count === 0) {
              resolve();
            } else {
              reject(count);
            }
            this.validators.map(validate => {
              validate.run = false;
            });
          }
        });
      });
    });
  }

  onSuccess (resolve) {
    this.context.showLoading();
    this.context.fetch(this.state.treatment.api_location.interview, {
      methods: 'POST',
      body: {
        treatment: {
          code: this.state.treatment.code,
          interviews: this.state.interviews,
        },
      },
    }).then(() => {
      this.setState({ isSaved: true });
      setTimeout(() => {
        const ids = location.pathname.split('/').filter(s => s !== '').slice(-6);
        const search = new URLSearchParams(location.search);
        if (!search.get('interview')) {
          search.append('interview', '1');
        }
        location.href = `${CompleteInstitutionMenuTreatmentPath(ids[0], ids[2], ids[4])}?${search.toString()}`;
      }, 10);
    }).finally(() => {
      this.constext.hideLoading();
      resolve();
    });
  }

  renderTextarea (interview, setting) {
    return (
      <div>
        <div className="p-interview--content--annotation ta-r">{interview.text?.length || '0'}/{this.maxText}</div>
        <MnInputTextarea
          name={interview.interview_setting_code}
          value={interview.text}
          placeholder={setting.annotation}
          onValidate={ this.onValidate }
          validates={ InterviewValidators.text_i18n }
          onChange={this.onChangeText}
          t={this.context.t}
        />
      </div>
    );
  }

  renderRadio (interview, setting) {
    return (
      <div>
        <div className="p-interview--content--annotation">{this.context.formatSimple(setting.annotation)}</div>
        <MnInputRadioGroup
          groups={InterviewsSelects}
          name={interview.interview_setting_code}
          value={interview.select}
          onChange={this.onChangeSelect}
          t={this.context.t}
        />
      </div>
    );
  }

  renderFile (interview, setting, index) {
    return (
      <div>
        <div className="p-interview--content--annotation">{this.context.formatSimple(setting.annotation)}</div>
        <MnInputFile
          ref={this.files[index]}
          name={interview.interview_setting_code}
          title='InterviewForm.add_image'
          icon={() => SvgPlusIcon}
          acceptMime={this.state.treatment.mime_types}
          uploadFile={UserApiV1InstitutionUploadFilesPath(this.state.treatment.menu.institution.code)}
          onChange={this.onChangeFiles}
          t={this.context.t}
        />
      </div>
    );
  }

  renderInput (interview, setting, index) {
    switch (setting.input_type) {
    case 'textarea':
      return this.renderTextarea(interview, setting, index);
    case 'radio':
      return this.renderRadio(interview, setting, index);
    case 'file':
      return this.renderFile(interview, setting, index);
    }
  }

  renderTermsLink () {
    const url = (this.state?.menu?.treatment_category === 'regional_medical_cooperation') ? RegionalMedicalCooperationTermsPath() : TermsInstitutionsPath();
    return (
      <a target="_blank" rel="noreferrer" href={url}>
        {this.context.t('Treatment.terms')}
      </a>
    );
  }

  render () {
    console.log(this.state);
    const interviews = this.state?.menu?.interview_settings || [];
    const { t } = this.context;
    return (
      <div className="p-container p-interview">
        <div className="l-conatiner">
          <h4 className="w90p c-mn-title-2 ta-c">{t('InterviewForm.title')}</h4>
          <div className="p-interview--content">
            {interviews.map((setting, index) => {
              return (
                <div key={setting.code}>
                  <p>{setting.title}</p>
                  {this.renderInput(this.state.interviews[index], setting, index)}
                </div>
              );
            })}
          </div>
          <div className="p-interview--annotation">
            <span><a target="_blank" rel="noreferrer" href="https://medicalnote.co.jp/privacy">{t('Treatment.privacy_policy')}</a>・{this.renderTermsLink()}</span>
          </div>
          <div className="p-interview--submit">
            <MnButton class="c-mn-btn--first m-a" onClick={this.onSave}><span>{t('InterviewForm.agree_and_submit')}</span></MnButton>
          </div>
        </div>
      </div>
    );
  }
}
